<template>
    <div>
        <div class="section section_five">
            <div class="main_content">
                <div class="container">
                    <div class="heading_section">
                        <h2  data-aos="fade-up">{{socialbusiness.section_one.title}}</h2> 
                    </div>
                    <div class="row mb-20">
                        <div class="col-md-12 full-content ml-md-auto mx-md-0 mx-auto mb-md-0 mb-4">
                            <div class="custom_border ml-auto">
                                <p  data-aos="fade-up" v-html="socialbusiness.section_one.richtext[0]">
                                    <!-- {{socialbusiness.section_one.richtext[0]}} -->
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-20">
                        <div class="col-md-12 full-content mx-md-0 mx-auto mb-md-0 mb-4">
                            <div class="custom_border">
                                <p  data-aos="fade-up" v-html="socialbusiness.section_one.richtext[1]">
                                    <!-- {{socialbusiness.section_one.richtext[1]}} -->
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 full-content ml-md-auto mx-md-0 mx-auto mb-md-0 mb-4">
                            <div class="custom_border ml-auto">
                                <p  data-aos="fade-up" v-html="socialbusiness.section_one.richtext[2]">
                                    <!-- {{socialbusiness.section_one.richtext[2]}} -->
                                </p>
                            </div>
                        </div>
                        <!-- <div class="col-md-12">
                            <div class="icon">
                                <img :src="require(`../../assets/images/corporate-sustainability/${this.climate.Icons[0].image}`)" alt="" class="img-fluid">
                            </div>
                            <div class="custom_border note">
                                <h5 v-html="this.climate.RichText4">
                                    {{this.climate.RichText4}}
                                </h5>
                            </div>
                        </div> -->
                    </div>
                    <div class="heading_section mt-100">
                        <h2 class="text-left"  data-aos="fade-up">{{socialbusiness.section_two.title}}</h2>
                    </div>
                    <div class="row mb-20">
                        <div class="col-md-12 full-content ml-auto">
                            <div class="custom_border ml-auto">
                                <p  data-aos="fade-up" v-html="socialbusiness.section_two.richtext_one">
                                    <!-- {{socialbusiness.section_two.richtext_one}} -->
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-20">
                        <div class="col-md-8">
                            <div class="table-wrapper"  data-aos="fade-up">
                                <table>
                                    <thead>
                                        <tr>
                                            <th  v-for="(header, index) in socialbusiness.section_two.table.thead" :key="index" v-html="header"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(body, index) in socialbusiness.section_two.table.tbody" :key="index">
                                            <td v-for="(data, index) in body.data" :key="index">{{data}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-20">
                        <div class="col-md-6 mb-md-0 mb-4">
                            <div class="chart-stat"  data-aos="fade-up">
                                <div class="row">
                                    <div class="col-md-8 col-7">
                                        <div class="image">
                                            <img :src="require(`../../assets/images/corporate-sustainability/svg/${socialbusiness.section_two.imageSection.image}`)" alt="">
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-5">
                                        <div class="childNumber" v-if="$i18n.locale=='en'">
                                            <span class="digit counter" data-number="150"></span>
                                            {{socialbusiness.section_two.imageSection.counterText}}
                                        </div>
                                        <div class="childNumber" v-if="$i18n.locale=='ar'">
                                            <span class="digit counter" data-number="156"></span>
                                            <span v-html="socialbusiness.section_two.imageSection.counterText"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 mb-md-0 mb-4">
                            <div class="custom_border ml-auto" >
                                <p  data-aos="fade-up" v-html="socialbusiness.section_two.imageSection.richtext">
                                    <!-- {{socialbusiness.section_two.imageSection.richtext}} -->
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="social-note" v-html="socialbusiness.section_two.imageSection.lastText"  data-aos="fade-up"></div>
                </div>
                
            </div>
        </div>
    </div>
</template>

<script>
const sociabusiness = [];
export default {
    name:"sociabusiness",
    props:{
        socialbusiness: Object
    },
    mounted(){
        this.counterAnimation();
    }
}
</script>

<style lang="scss" scoped>
    /deep/{
        .mt-100{
            margin-top: 40px !important;
        }
    }
    .section_five{
        @include Background('../../assets/images/corporate-sustainability/bg4.png');
        h2{
            @include Heading(center)
        }
        .social-note{
            padding:rem(40px) 0;
            font-size:rem(25px);
            color:#fff;
            font-weight:700;
            /deep/ span{
                font-weight: 900;
                font-size:rem(35px);
            }
        }
        .note {
            
            max-width: 100%;
            margin-top: rem(50px);
            padding-top: rem(30px);
            margin-bottom: rem(60px);
            &.custom_border {
                &:before {
                    top: 0;
                }
            }
            h5 {
                font-size: rem(50px);
                color: #ffffff;
                font-weight: normal;  
                /deep/ span {
                    font-weight: 700; 
                    &.big {
                        font-size: rem(65px);
                    }
                }
            }
        }
        
        .table-wrapper {
            color: #ffffff;
            margin-top: rem(50px);
            table {
                thead {
                    border-bottom: 4px solid #06A976;
                    th {
                        font-size: rem(35px);
                        font-weight: 700;
                        padding: 20px 0;
                        @media screen and (max-width:991px){
                            font-size: rem(25px);
                            padding:15px 0;
                        }
                        &:last-child {
                            text-align: center;
                            @media screen and (max-width:991px){
                                padding-left:rem(16px);
                            }
                        }
                    }
                }
                tbody {
                    td {
                        font-size: rem(20px);
                        padding: 20px 0;
                        line-height: 1.25;
                        @media screen and (max-width:991px){
                            font-size: rem(16px);
                            padding:15px 0;
                        }
                        &:last-child {
                            text-align: center;
                            @media screen and (max-width:991px){
                                padding-left:rem(16px);
                            }
                        }
                    }
                    
                }
            }
        }



    .chart-stat{
        position: relative;
        padding-top:rem(20px);
        .image{
            max-width:100%;
        }
        .childNumber{
            position: static;
            font-size: rem(22px);
            color: #fff;
            font-weight: bold;
            line-height:1.2;
            @media screen and (max-width:991px) {
                margin-top: 10px;
                font-size: rem(16px);
            }
            .digit{
                position: static;
                font-size: 35px;
                display:block;
                @media screen and (max-width:991px) {
                    font-size: 28px;
                }
            }
        }
    }   
    }

    // arabic
    [lang="ar"] {
        .section_five{
           
            .table-wrapper {
                table {
                    thead {
                        th {
                            
                            &:last-child {
                                
                                @media screen and (max-width:991px){
                                    padding-right:rem(16px);
                                    padding-left: 0;
                                }
                            }
                        }
                    }
                    tbody {
                        td {
                            
                            &:last-child {
                                
                                @media screen and (max-width:991px){
                                    padding-right:rem(16px);
                                    padding-left: 0;
                                }
                            }
                        }
                        
                    }
                }
            }

        }
    }
</style>